export const OFF_ROAD_LEAD_CAT_ID = 14;
export const YAMAHA_ADVENTURE_PATH = '/guided-motorcycle-tours/yamaha-mojave-desert-adventure?ref=off-road-landing';
export const OFF_ROAD_LANDING_REF ='off-road-landing';

export const UTV_2_DAY_PROMO_AVAILABLE_DATES_YEAR = 2026;
export const UTV_2_DAY_PROMO_AVAILABLE_DATES = [
  'Sep 10–11',
  'Oct 15–16',
  'Nov 1–2',
] as const;